import { render, staticRenderFns } from "./ProveedorV.vue?vue&type=template&id=3cbc8eb2"
import script from "./ProveedorV.vue?vue&type=script&lang=js"
export * from "./ProveedorV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports